import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useBlog } from "../hooks";
import BlogArticleCard from "../components/BlogArticleCard";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";

const BlogPage = () => {
    let navigate = useNavigate();
    const { blog } = useBlog();

    return (
        <>
            <PageTitle>NEWS</PageTitle>
            <PageContent>
                <Grid
                    container
                    sx={{ alignItems: "center", justifyContent: "center" }}
                    spacing={4}
                >
                    {blog.map((item) => (
                        <Grid item md={6} lg={3} sx={{ width: "100%" }}>
                            <BlogArticleCard
                                item={item}
                                onLearnMore={() => {navigate(`${item.id}/detail`)}}
                            />
                        </Grid>
                    ))}
                </Grid>
            </PageContent>
        </>
    );
};

export default BlogPage;
